export enum QuestionType {
  LongText = "LongText",
  ShortText = "ShortText",
  SingleSelection = "SingleSelection",
  MultipleSelection = "MultipleSelection",
  Level = "Level",
  Tags = "Tags",
}
